import React, { FC, ReactNode, useState } from "react";
import { cn } from "@/lib/utils";
import { ChevronDown, ChevronUp } from "lucide-react";

interface FoldableContainerProps {
  titleNode: ReactNode;
  extraNode?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export const FoldableContainer: FC<FoldableContainerProps> = ({
  titleNode,
  extraNode,
  children,
  className,
  contentClassName,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <button
        type="button"
        className="flex h-10 w-full flex-row items-center justify-between gap-2.5 rounded-lg border border-neutral-200 bg-white px-4 text-left shadow-xs"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex min-w-0 flex-row items-center gap-2 text-sm font-medium text-neutral-900">
          {titleNode}
          {extraNode}
        </div>
        {isExpanded ? (
          <ChevronUp className="size-4 shrink-0 text-neutral-900" />
        ) : (
          <ChevronDown className="size-4 shrink-0 text-neutral-900" />
        )}
      </button>
      {isExpanded && (
        <div className={cn("flex flex-col gap-2 px-4 pb-2", contentClassName)}>
          {children}
        </div>
      )}
    </div>
  );
};
